(function () {
  'use strict';

  var CONFIG = {
    debug: window.location.search.indexOf('sb_debug=1') !== -1,
    expandSubscriptionBundles:
      window.__SB_EXPAND_SUBSCRIPTION_BUNDLES__ !== false &&
      window.location.search.indexOf('sb_expand=0') === -1,
    selectors: {
      productForm: 'form[action="/cart/add"], form[action*="/cart/add"]',
      variantInput: 'input[name="id"], select[name="id"]',
      sellingPlanInput: 'input[name="selling_plan"], select[name="selling_plan"]',
      quantityInput: 'input[name="quantity"]',
    },
  };

  var Logger = {
    prefix: '[SB-Expander]',
    log: function () {
      if (!CONFIG.debug) return;
      var args = [this.prefix].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    },
    warn: function () {
      var args = [this.prefix].concat(Array.prototype.slice.call(arguments));
      console.warn.apply(console, args);
    },
    error: function () {
      var args = [this.prefix].concat(Array.prototype.slice.call(arguments));
      console.error.apply(console, args);
    },
  };

  var _originalFetch = window.fetch.bind(window);

  var MetafieldCache = {
    _cache: {},
    get: function (variantId) {
      return this._cache[String(variantId)];
    },
    set: function (variantId, data) {
      this._cache[String(variantId)] = data;
    },
    has: function (variantId) {
      return Object.prototype.hasOwnProperty.call(this._cache, String(variantId));
    },
  };

  var ProductDataCache = {
    _cache: {},

    fetch: function (handle) {
      var productHandle = String(handle || '').trim();
      if (!productHandle) return Promise.resolve(null);

      if (!this._cache[productHandle]) {
        this._cache[productHandle] = _originalFetch(Utils.getProductJsonUrl(productHandle), {
          headers: {
            Accept: 'application/json',
          },
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Unable to load product data for handle "' + productHandle + '".');
            }

            return response.json();
          })
          .then(function (product) {
            return ProductDataCache.prepare(product);
          })
          .catch(function (error) {
            delete ProductDataCache._cache[productHandle];
            throw error;
          });
      }

      return this._cache[productHandle];
    },

    prepare: function (product) {
      if (!product || product.__sbPrepared) return product;

      var planIndex = {};
      var groups = Array.isArray(product.selling_plan_groups) ? product.selling_plan_groups : [];

      for (var i = 0; i < groups.length; i += 1) {
        var group = groups[i] || {};
        var groupId = String(group.id || '');
        var groupName = String(group.name || '');
        var sellingPlans = Array.isArray(group.selling_plans) ? group.selling_plans : [];

        for (var j = 0; j < sellingPlans.length; j += 1) {
          var plan = sellingPlans[j] || {};
          var planId = String(plan.id || '');
          if (!planId) continue;

          planIndex[planId] = {
            id: planId,
            name: String(plan.name || ''),
            normalizedName: Utils.normalizeText(plan.name || ''),
            optionSignature: Utils.optionSignature(plan.options),
            priceAdjustmentSignature: Utils.priceAdjustmentSignature(plan.price_adjustments),
            deliverySignature: Utils.deliverySignature([plan.name, groupName, Utils.optionsText(plan.options)].join(' ')),
            groupId: groupId,
            groupName: groupName,
            normalizedGroupName: Utils.normalizeText(groupName),
          };
        }
      }

      product.__sbPrepared = true;
      product.__sbPlanIndex = planIndex;
      return product;
    },
  };

  var Utils = {
    isPlainObject: function (value) {
      return Object.prototype.toString.call(value) === '[object Object]';
    },

    normalizeQuantity: function (value) {
      var quantity = parseInt(value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    },

    hasSellingPlan: function (value) {
      return value !== null && value !== undefined && String(value).trim() !== '';
    },

    cloneProperties: function (properties) {
      if (!Utils.isPlainObject(properties)) return {};

      var cloned = {};
      Object.keys(properties).forEach(function (key) {
        var value = properties[key];
        if (value === null || value === undefined || value === '') return;
        cloned[key] = value;
      });

      return cloned;
    },

    isEmptyObject: function (value) {
      return !value || Object.keys(value).length === 0;
    },

    parseJSON: function (value) {
      try {
        return JSON.parse(value);
      } catch (_error) {
        return null;
      }
    },

    appendKeyValue: function (target, key, value) {
      target[key] = value;
    },

    formDataToObject: function (formData) {
      var data = {};

      formData.forEach(function (value, key) {
        Utils.appendKeyValue(data, key, value);
      });

      return data;
    },

    urlSearchParamsToObject: function (params) {
      var data = {};

      params.forEach(function (value, key) {
        Utils.appendKeyValue(data, key, value);
      });

      return data;
    },

    collectProperties: function (data) {
      if (!Utils.isPlainObject(data)) return {};

      var properties = Utils.cloneProperties(data.properties);

      Object.keys(data).forEach(function (key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (!match) return;
        properties[match[1]] = data[key];
      });

      return properties;
    },

    normalizeItem: function (item, sharedProperties) {
      if (!item || item.id === null || item.id === undefined || item.id === '') return null;

      var normalized = {
        id: parseInt(item.id, 10),
        quantity: Utils.normalizeQuantity(item.quantity),
        properties: Utils.cloneProperties(item.properties || sharedProperties),
      };

      if (!Number.isFinite(normalized.id)) return null;

      if (Utils.hasSellingPlan(item.selling_plan)) {
        normalized.selling_plan = String(item.selling_plan);
      }

      return normalized;
    },

    parseCartAddBody: function (body) {
      var data = null;
      var bodyType = 'unknown';

      if (body instanceof FormData) {
        bodyType = 'formdata';
        data = Utils.formDataToObject(body);
      } else if (typeof body === 'string') {
        var jsonBody = Utils.parseJSON(body);
        bodyType = jsonBody ? 'json-string' : 'urlencoded';
        data = jsonBody || Utils.urlSearchParamsToObject(new URLSearchParams(body));
      } else if (Utils.isPlainObject(body)) {
        bodyType = 'json-object';
        data = body;
      }

      if (!Utils.isPlainObject(data)) return null;

      var sharedProperties = Utils.collectProperties(data);
      var rawItems = [];

      if (Array.isArray(data.items)) {
        rawItems = data.items;
      } else if (data.id !== null && data.id !== undefined && data.id !== '') {
        rawItems = [
          {
            id: data.id,
            quantity: data.quantity,
            selling_plan: data.selling_plan,
            properties: sharedProperties,
          },
        ];
      }

      var items = rawItems
        .map(function (item) {
          return Utils.normalizeItem(item, sharedProperties);
        })
        .filter(Boolean);

      if (!items.length) return null;

      return {
        bodyType: bodyType,
        data: data,
        items: items,
        sections: data.sections || null,
        sections_url: data.sections_url || window.location.pathname,
      };
    },

    serializeProperties: function (properties) {
      var clone = Utils.cloneProperties(properties);
      var keys = Object.keys(clone).sort();
      var ordered = {};

      for (var i = 0; i < keys.length; i += 1) {
        ordered[keys[i]] = clone[keys[i]];
      }

      return JSON.stringify(ordered);
    },

    mergeItems: function (items) {
      var merged = {};
      var orderedKeys = [];

      items.forEach(function (item) {
        var normalized = Utils.normalizeItem(item, item.properties || {});
        if (!normalized) return;

        var properties = Utils.cloneProperties(normalized.properties);
        var key =
          String(normalized.id) +
          '::' +
          String(normalized.selling_plan || '') +
          '::' +
          Utils.serializeProperties(properties);

        if (!merged[key]) {
          merged[key] = {
            id: normalized.id,
            quantity: normalized.quantity,
          };

          if (Utils.hasSellingPlan(normalized.selling_plan)) {
            merged[key].selling_plan = normalized.selling_plan;
          }

          if (!Utils.isEmptyObject(properties)) {
            merged[key].properties = properties;
          }

          orderedKeys.push(key);
          return;
        }

        merged[key].quantity += normalized.quantity;
      });

      return orderedKeys.map(function (key) {
        return merged[key];
      });
    },

    getFetchMeta: function (input, options) {
      var request = input instanceof Request ? input : null;
      var url = request ? request.url : input;
      var method = (options && options.method) || (request && request.method) || 'GET';
      var body = options && Object.prototype.hasOwnProperty.call(options, 'body') ? options.body : null;

      return {
        url: String(url || ''),
        method: String(method || 'GET').toUpperCase(),
        body: body,
      };
    },

    isCartAddRequest: function (meta) {
      return meta.method === 'POST' && meta.url.indexOf('/cart/add') !== -1 && meta.body !== null;
    },

    extractFormProperties: function (form) {
      var formData = new FormData(form);
      return Utils.collectProperties(Utils.formDataToObject(formData));
    },

    getCartSectionIds: function () {
      var sectionIds = [];
      var seen = {};
      var cartItemsComponents = document.querySelectorAll('cart-items-component');

      cartItemsComponents.forEach(function (component) {
        if (!(component instanceof HTMLElement)) return;
        var sectionId = component.dataset.sectionId;
        if (!sectionId || seen[sectionId]) return;
        seen[sectionId] = true;
        sectionIds.push(sectionId);
      });

      return sectionIds;
    },

    buildResponse: function (status, payload) {
      return new Response(JSON.stringify(payload || {}), {
        status: status,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },

    buildSuccessPayload: function (payload, meta) {
      var responsePayload = {};

      if (Array.isArray(payload)) {
        responsePayload.items = payload;
      } else if (Utils.isPlainObject(payload)) {
        responsePayload = Object.assign({}, payload);
      }

      responsePayload.__sbExpander = {
        expanded: true,
        itemCount: meta.itemCount,
      };

      return responsePayload;
    },

    buildErrorPayload: function (status, payload, fallbackMessage) {
      if (Utils.isPlainObject(payload)) {
        return payload;
      }

      return {
        status: status,
        message: fallbackMessage || 'Unable to add this bundle to the cart.',
        description: fallbackMessage || 'Unable to add this bundle to the cart.',
      };
    },

    getRootUrl: function () {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }

      return '/';
    },

    getProductJsonUrl: function (handle) {
      return Utils.getRootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
    },

    normalizeText: function (value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    },

    optionSignature: function (options) {
      if (!Array.isArray(options) || !options.length) return '';

      return options
        .map(function (option) {
          if (!option) return '';

          var position = option.position || 0;
          var name = Utils.normalizeText(option.name || '');
          var value = Utils.normalizeText(option.value || '');

          return String(position) + ':' + name + '=' + value;
        })
        .filter(Boolean)
        .join('|');
    },

    optionsText: function (options) {
      if (!Array.isArray(options) || !options.length) return '';

      return options
        .map(function (option) {
          if (!option) return '';
          return [option.name, option.value].filter(Boolean).join(' ');
        })
        .filter(Boolean)
        .join(' ');
    },

    deliverySignature: function (value) {
      var text = Utils.normalizeText(value)
        .replace(/\bdelivered\b/g, 'deliver')
        .replace(/\bdelivery\b/g, 'deliver')
        .replace(/\bships\b/g, 'ship')
        .replace(/\bshipping\b/g, 'ship');

      if (!text) return '';

      var match =
        text.match(/(?:every|each|per)\s+(\d+)?\s*(day|week|month|year)s?/) ||
        text.match(/(\d+)\s*(day|week|month|year)s?/);

      if (!match) return '';

      var quantity = match[1] || '1';
      var unit = match[2] || '';
      return quantity + ':' + unit;
    },

    priceAdjustmentSignature: function (adjustments) {
      if (!Array.isArray(adjustments) || !adjustments.length) return '';

      return adjustments
        .map(function (adjustment) {
          if (!adjustment) return '';
          var position = adjustment.position !== undefined ? adjustment.position : '';
          var orderCount = adjustment.order_count !== undefined ? adjustment.order_count : '';
          var valueType = adjustment.value_type || adjustment.adjustment_type || '';
          var value = adjustment.value !== undefined ? adjustment.value : adjustment.adjustment_value;

          return [
            String(position),
            String(orderCount),
            Utils.normalizeText(valueType),
            value !== undefined ? String(value) : '',
          ].join(':');
        })
        .filter(Boolean)
        .join('|');
    },

    normalizePrice: function (value) {
      var price = Number(value);
      return Number.isFinite(price) ? price : null;
    },

    calculateDiscountPercent: function (price, compareAtPrice) {
      var currentPrice = Utils.normalizePrice(price);
      var originalPrice = Utils.normalizePrice(compareAtPrice);

      if (currentPrice === null || originalPrice === null || originalPrice <= currentPrice || originalPrice <= 0) {
        return null;
      }

      return Math.round(((originalPrice - currentPrice) / originalPrice) * 10000) / 100;
    },

    centsToDecimalString: function (value) {
      var cents = Utils.normalizePrice(value);
      if (cents === null) return '';
      return (Math.round(cents) / 100).toFixed(2);
    },

    appendHiddenProperty: function (properties, key, value) {
      if (value === null || value === undefined || value === '') return;
      properties[key] = String(value);
    },

    buildBundleProperties: function (existingProperties, parentContext, metafields) {
      var properties = Utils.cloneProperties(existingProperties);
      var bundleLabel = (metafields && metafields.productTitle) || parentContext.productTitle || 'Bundle';

      properties.Bundle = bundleLabel;
      properties._sb_bundle = 'true';
      properties._sb_bundle_parent_variant_id = String(parentContext.variantId || '');
      properties._sb_bundle_parent_handle = String(parentContext.productHandle || '');
      properties._sb_bundle_parent_title = String(bundleLabel || '');

      if (metafields && metafields.bundleType) {
        properties._sb_bundle_type = String(metafields.bundleType);
      }

      return properties;
    },

    buildSubscriptionBundleProperties: function (existingProperties, parentContext, metafields, planContext, pricing) {
      var properties = Utils.buildBundleProperties(existingProperties, parentContext, metafields);
      var parentPlan = planContext && planContext.parentPlan;
      var childPlan = planContext && planContext.childPlan;

      Utils.appendHiddenProperty(properties, '_sb_bundle_parent_selling_plan_id', parentContext.sellingPlanId);

      if (parentPlan) {
        Utils.appendHiddenProperty(properties, '_sb_bundle_parent_selling_plan_price', parentPlan.price);
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_parent_subscription_discount_percent',
          parentPlan.discountPercent
        );
      }

      if (childPlan) {
        Utils.appendHiddenProperty(properties, '_sb_bundle_child_selling_plan_id', childPlan.id);
        Utils.appendHiddenProperty(properties, '_sb_bundle_child_selling_plan_price', childPlan.price);
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_child_subscription_discount_percent',
          childPlan.discountPercent
        );
      }

      if (pricing) {
        Utils.appendHiddenProperty(properties, '_sb_bundle_pricing_source', 'parent_bundle_subscription_price');
        Utils.appendHiddenProperty(properties, '_sb_bundle_allocated_line_price', pricing.allocatedLinePrice);
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_allocated_line_price_decimal',
          Utils.centsToDecimalString(pricing.allocatedLinePrice)
        );
        Utils.appendHiddenProperty(properties, '_sb_bundle_allocated_unit_price', pricing.allocatedUnitPrice);
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_allocated_unit_price_decimal',
          Utils.centsToDecimalString(pricing.allocatedUnitPrice)
        );
        Utils.appendHiddenProperty(properties, '_sb_bundle_child_line_price', pricing.childLinePrice);
        Utils.appendHiddenProperty(properties, '_sb_bundle_discount_line_amount', pricing.discountLineAmount);
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_discount_percent',
          pricing.discountPercent
        );
        Utils.appendHiddenProperty(
          properties,
          '_sb_bundle_requires_price_adjustment',
          pricing.requiresPriceAdjustment ? 'true' : 'false'
        );
      }

      return properties;
    },
  };

  var MetafieldFetcher = {
    fetch: function (variantId) {
      var key = String(variantId);

      if (MetafieldCache.has(key)) {
        return MetafieldCache.get(key);
      }

      var metafields = {
        productHandle: null,
        productTitle: null,
        variantPrice: null,
        variantCompareAtPrice: null,
        simpleComponents: null,
        ioSelections: null,
        bundleType: null,
      };

      if (window.__SB_VARIANT_METAFIELDS__ && window.__SB_VARIANT_METAFIELDS__[key]) {
        var data = window.__SB_VARIANT_METAFIELDS__[key];
        metafields.productHandle = data.product_handle || null;
        metafields.productTitle = data.product_title || null;
        metafields.variantPrice = Utils.normalizePrice(data.variant_price);
        metafields.variantCompareAtPrice = Utils.normalizePrice(data.variant_compare_at_price);
        metafields.simpleComponents = data.simple_bundle_components || null;
        metafields.ioSelections = this.parseIOSelections(data.bundle_component_selections);
        metafields.bundleType = data.bundle_type || null;
      }

      MetafieldCache.set(key, metafields);
      return metafields;
    },

    parseIOSelections: function (value) {
      if (!value) return null;
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') return Utils.parseJSON(value);
      return null;
    },
  };

  var BundleDetector = {
    isBundle: function (metafields) {
      if (!metafields) return false;

      var hasSimpleComponents =
        Array.isArray(metafields.simpleComponents) && metafields.simpleComponents.length > 0;
      var hasIOSelections = Array.isArray(metafields.ioSelections) && metafields.ioSelections.length > 0;

      return hasSimpleComponents || hasIOSelections;
    },

    getBundleType: function (metafields) {
      if (!metafields) return null;
      if (metafields.bundleType) return metafields.bundleType;
      if (Array.isArray(metafields.ioSelections) && metafields.ioSelections.length > 0) return 'infinite_options';
      if (Array.isArray(metafields.simpleComponents) && metafields.simpleComponents.length > 0) return 'simple';
      return null;
    },
  };

  var ComponentResolver = {
    normalizeResolvedComponent: function (config, bundleQuantity) {
      var variantId = parseInt(config.id, 10);
      var componentQuantity = parseInt(config.quantity, 10);

      if (!Number.isFinite(variantId) || !Number.isFinite(componentQuantity) || componentQuantity <= 0) {
        return null;
      }

      return {
        id: variantId,
        quantity: componentQuantity * bundleQuantity,
        productHandle: config.productHandle || null,
      };
    },

    resolveSimpleBundle: function (components, quantity) {
      if (!Array.isArray(components) || !components.length) return [];

      var bundleQuantity = Utils.normalizeQuantity(quantity);
      var resolved = [];

      for (var i = 0; i < components.length; i += 1) {
        var component = components[i];
        var normalized = null;

        if (Array.isArray(component)) {
          normalized = this.normalizeResolvedComponent(
            {
              id: component[0],
              quantity: component[1] || 1,
              productHandle: typeof component[2] === 'string' ? component[2] : null,
            },
            bundleQuantity
          );
        } else if (component && typeof component === 'object') {
          normalized = this.normalizeResolvedComponent(
            {
              id: component.variant_id || component.id,
              quantity: component.quantity || component.quantity_in_bundle || 1,
              productHandle: component.product_handle || component.handle || null,
            },
            bundleQuantity
          );
        }

        if (normalized) {
          resolved.push(normalized);
        }
      }

      return resolved;
    },

    resolveIOBundle: function (ioSelections, bundleSelectionString, quantity) {
      if (!Array.isArray(ioSelections) || !bundleSelectionString) return [];

      var selectedOptions = String(bundleSelectionString)
        .split('<>')
        .map(function (value) {
          return value.trim();
        })
        .filter(Boolean);

      if (!selectedOptions.length) return [];

      var bundleQuantity = Utils.normalizeQuantity(quantity);
      var resolved = [];

      for (var i = 0; i < selectedOptions.length; i += 1) {
        var selection = selectedOptions[i];
        var found = false;

        for (var j = 0; j < ioSelections.length && !found; j += 1) {
          var group = ioSelections[j];
          if (!Utils.isPlainObject(group)) continue;

          var keys = Object.keys(group);

          for (var k = 0; k < keys.length; k += 1) {
            var optionName = keys[k];
            var normalizedOptionName = String(optionName).toLowerCase();
            var normalizedSelection = String(selection).toLowerCase();

            if (
              normalizedOptionName !== normalizedSelection &&
              normalizedSelection.indexOf(normalizedOptionName) === -1 &&
              normalizedOptionName.indexOf(normalizedSelection) === -1
            ) {
              continue;
            }

            var variantData = group[optionName];
            if (!Array.isArray(variantData)) continue;

            for (var v = 0; v < variantData.length; v += 1) {
              var item = variantData[v];
              var normalized = null;

              if (Array.isArray(item)) {
                var metadata = Utils.isPlainObject(item[2]) ? item[2] : null;

                normalized = this.normalizeResolvedComponent(
                  {
                    id: item[0],
                    quantity: item[1] || 1,
                    productHandle:
                      (metadata && (metadata.product_handle || metadata.handle)) ||
                      (typeof item[2] === 'string' ? item[2] : null),
                  },
                  bundleQuantity
                );
              } else if (item && typeof item === 'object') {
                normalized = this.normalizeResolvedComponent(
                  {
                    id: item.variant_id || item.id,
                    quantity: item.quantity || item.quantity_in_bundle || 1,
                    productHandle: item.product_handle || item.handle || null,
                  },
                  bundleQuantity
                );
              }

              if (normalized) {
                resolved.push(normalized);
              }
            }

            found = true;
            break;
          }
        }

        if (!found) {
          Logger.warn('No Infinite Options match found for selection:', selection);
        }
      }

      return resolved;
    },

    extractBundleSelection: function (properties) {
      if (!properties || !properties._bundle_selection) return null;

      var selection = properties._bundle_selection;

      try {
        return decodeURIComponent(String(selection).replace(/\+/g, ' '));
      } catch (_error) {
        return selection;
      }
    },
  };

  var SellingPlanMapper = {
    getVariant: function (product, variantId) {
      if (!product || !Array.isArray(product.variants)) return null;

      var selectedVariantId = parseInt(variantId, 10);
      if (!Number.isFinite(selectedVariantId)) return null;

      for (var i = 0; i < product.variants.length; i += 1) {
        if (parseInt(product.variants[i].id, 10) === selectedVariantId) {
          return product.variants[i];
        }
      }

      return null;
    },

    getVariantPlans: function (product, variantId) {
      if (!product || !Array.isArray(product.variants)) return [];

      var variant = SellingPlanMapper.getVariant(product, variantId);

      if (!variant || !Array.isArray(variant.selling_plan_allocations)) return [];

      var planIndex = product.__sbPlanIndex || {};

      return variant.selling_plan_allocations.map(function (allocation) {
        var planId = String(allocation.selling_plan_id || '');
        var planMeta = planIndex[planId] || {};

        return {
          id: planId,
          name: planMeta.name || '',
          normalizedName: planMeta.normalizedName || '',
          optionSignature: planMeta.optionSignature || '',
          priceAdjustmentSignature: planMeta.priceAdjustmentSignature || Utils.priceAdjustmentSignature(allocation.price_adjustments),
          deliverySignature: planMeta.deliverySignature || '',
          groupId: String(allocation.selling_plan_group_id || planMeta.groupId || ''),
          groupName: planMeta.groupName || '',
          normalizedGroupName: planMeta.normalizedGroupName || '',
          price: Utils.normalizePrice(allocation.price),
          compareAtPrice: Utils.normalizePrice(allocation.compare_at_price),
          perDeliveryPrice: Utils.normalizePrice(allocation.per_delivery_price),
          discountPercent: Utils.calculateDiscountPercent(allocation.price, allocation.compare_at_price),
        };
      });
    },

    getPlanForVariant: function (productHandle, variantId, sellingPlanId) {
      var requestedPlanId = String(sellingPlanId || '');
      if (!productHandle || !requestedPlanId) return Promise.resolve(null);

      return ProductDataCache.fetch(productHandle).then(function (product) {
        var plans = SellingPlanMapper.getVariantPlans(product, variantId);

        for (var i = 0; i < plans.length; i += 1) {
          if (plans[i].id === requestedPlanId) {
            return plans[i];
          }
        }

        return null;
      });
    },

    getChildPlans: function (component) {
      var productHandle = component.productHandle || null;
      if (!productHandle) return Promise.resolve([]);

      return ProductDataCache.fetch(productHandle).then(function (product) {
        return SellingPlanMapper.getVariantPlans(product, component.id);
      });
    },

    findPlanClosestToLinePrice: function (childPlans, quantity, targetLinePrice, currentPlan) {
      if (!Array.isArray(childPlans) || !childPlans.length) return null;

      var normalizedTarget = Utils.normalizePrice(targetLinePrice);
      if (normalizedTarget === null || normalizedTarget <= 0) return null;

      var normalizedQuantity = Utils.normalizeQuantity(quantity);
      var bestPlan = null;
      var bestDiff = Infinity;

      childPlans.forEach(function (plan) {
        var planPrice = Utils.normalizePrice(plan && plan.price);
        if (planPrice === null) return;

        var diff = Math.abs(planPrice * normalizedQuantity - normalizedTarget);
        if (diff < bestDiff) {
          bestDiff = diff;
          bestPlan = plan;
        }
      });

      if (!bestPlan) return null;

      var currentPrice = currentPlan ? Utils.normalizePrice(currentPlan.price) : null;
      var currentDiff = currentPrice === null ? Infinity : Math.abs(currentPrice * normalizedQuantity - normalizedTarget);
      var tolerance = Math.max(2, Math.round(normalizedTarget * 0.005));

      if (bestDiff <= tolerance && bestDiff < currentDiff) {
        return bestPlan;
      }

      return null;
    },

    matchPlan: function (parentPlan, childPlans) {
      if (!Array.isArray(childPlans) || !childPlans.length) return null;

      if (parentPlan) {
        var findBestPlan = function (plans) {
          if (!plans.length) return null;

          if (parentPlan.priceAdjustmentSignature) {
            for (var i = 0; i < plans.length; i += 1) {
              if (plans[i].priceAdjustmentSignature === parentPlan.priceAdjustmentSignature) {
                return plans[i];
              }
            }
          }

          if (parentPlan.discountPercent !== null && parentPlan.discountPercent !== undefined) {
            for (var j = 0; j < plans.length; j += 1) {
              if (
                plans[j].discountPercent !== null &&
                plans[j].discountPercent !== undefined &&
                Math.abs(plans[j].discountPercent - parentPlan.discountPercent) < 0.01
              ) {
                return plans[j];
              }
            }
          }

          return plans[0];
        };

        for (var i = 0; i < childPlans.length; i += 1) {
          if (childPlans[i].id === parentPlan.id) return childPlans[i];
        }

        var nameMatches = [];
        for (var j = 0; j < childPlans.length; j += 1) {
          if (parentPlan.name && childPlans[j].name === parentPlan.name) {
            nameMatches.push(childPlans[j]);
          }
        }
        var nameMatch = findBestPlan(nameMatches);
        if (nameMatch) return nameMatch;

        var normalizedNameMatches = [];
        for (var k = 0; k < childPlans.length; k += 1) {
          if (parentPlan.normalizedName && childPlans[k].normalizedName === parentPlan.normalizedName) {
            normalizedNameMatches.push(childPlans[k]);
          }
        }
        var normalizedNameMatch = findBestPlan(normalizedNameMatches);
        if (normalizedNameMatch) return normalizedNameMatch;

        var deliveryMatches = [];
        for (var d = 0; d < childPlans.length; d += 1) {
          if (parentPlan.deliverySignature && childPlans[d].deliverySignature === parentPlan.deliverySignature) {
            deliveryMatches.push(childPlans[d]);
          }
        }
        var deliveryMatch = findBestPlan(deliveryMatches);
        if (deliveryMatch) return deliveryMatch;

        var optionMatches = [];
        for (var v = 0; v < childPlans.length; v += 1) {
          var plan = childPlans[v];
          if (!parentPlan.optionSignature || plan.optionSignature !== parentPlan.optionSignature) continue;

          if (!parentPlan.normalizedGroupName || plan.normalizedGroupName === parentPlan.normalizedGroupName) {
            optionMatches.push(plan);
          }
        }
        var optionMatch = findBestPlan(optionMatches);
        if (optionMatch) return optionMatch;

        var discountMatch = findBestPlan(childPlans);
        if (discountMatch) return discountMatch;
      }

      if (childPlans.length === 1) {
        return childPlans[0];
      }

      return null;
    },

    resolveSellingPlanContext: function (parentContext, component) {
      if (!Utils.hasSellingPlan(parentContext.sellingPlanId)) {
        return Promise.resolve({
          sellingPlanId: null,
          parentPlan: null,
          childPlan: null,
          childPlans: [],
        });
      }

      if (!component.productHandle) {
        Logger.warn('Component is missing a product handle; falling back to parent selling plan ID.', component);
        return Promise.resolve({
          sellingPlanId: String(parentContext.sellingPlanId),
          parentPlan: null,
          childPlan: null,
          childPlans: [],
        });
      }

      return Promise.all([
        this.getPlanForVariant(parentContext.productHandle, parentContext.variantId, parentContext.sellingPlanId),
        this.getChildPlans(component),
      ]).then(function (results) {
        var parentPlan = results[0];
        var childPlans = results[1];
        var matchedPlan = SellingPlanMapper.matchPlan(parentPlan, childPlans);

        if (matchedPlan) {
          Logger.log(
            'Mapped parent selling plan',
            parentContext.sellingPlanId,
            'to child selling plan',
            matchedPlan.id,
            'for variant',
            component.id
          );

          return {
            sellingPlanId: matchedPlan.id,
            parentPlan: parentPlan,
            childPlan: matchedPlan,
            childPlans: childPlans,
          };
        }

        Logger.warn('No child selling plan match found; falling back to parent selling plan ID.', {
          parentVariantId: parentContext.variantId,
          parentSellingPlanId: parentContext.sellingPlanId,
          childVariantId: component.id,
          childProductHandle: component.productHandle,
          parentPlan: parentPlan,
          childPlans: childPlans,
        });

        if (childPlans.length) {
          return {
            sellingPlanId: childPlans[0].id,
            parentPlan: parentPlan,
            childPlan: childPlans[0],
            childPlans: childPlans,
          };
        }

        return {
          sellingPlanId: String(parentContext.sellingPlanId),
          parentPlan: parentPlan,
          childPlan: null,
          childPlans: childPlans,
        };
      });
    },

    resolveSellingPlan: function (parentContext, component) {
      return this.resolveSellingPlanContext(parentContext, component).then(function (planContext) {
        return planContext.sellingPlanId;
      });
    },
  };

  var CartAPI = {
    addUrl: function () {
      return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
    },

    addItems: function (payload) {
      Logger.log('Adding expanded bundle payload:', payload);

      return _originalFetch(this.addUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response.text().then(function (text) {
          return {
            ok: response.ok,
            status: response.status,
            data: Utils.parseJSON(text),
            text: text,
          };
        });
      });
    },

    getCart: function () {
      return _originalFetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      }).then(function (response) {
        return response.json();
      });
    },

    openCartDrawer: function () {
      var drawer =
        document.querySelector('#header-component .wc-header-cart-source cart-drawer-component') ||
        document.querySelector('#header-component cart-drawer-component') ||
        document.querySelector('cart-drawer-component');

      if (!drawer || typeof drawer.open !== 'function') return;
      drawer.open();
    },

    dispatchCartUpdate: function (cart, meta) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: meta.sourceId || 'simple-bundles-expander',
            data: {
              source: meta.source || 'simple-bundles-expander',
              itemCount: meta.itemCount,
              variantId: meta.variantId || '',
              productId: meta.productId || '',
              sections: meta.sections || {},
            },
          },
        })
      );
    },

    requestBundleDiscountSync: function () {
      document.dispatchEvent(
        new CustomEvent('simple-bundles:sync-discount', {
          bubbles: true,
        })
      );

      if (
        window.SimpleBundlesAutoDiscount &&
        typeof window.SimpleBundlesAutoDiscount.sync === 'function'
      ) {
        window.SimpleBundlesAutoDiscount.sync();
      }
    },
  };

  var Expander = {
    resolveBundleComponents: function (item, metafields) {
      var bundleType = BundleDetector.getBundleType(metafields);
      if (bundleType === 'simple') {
        return ComponentResolver.resolveSimpleBundle(metafields.simpleComponents, item.quantity);
      }

      if (bundleType === 'infinite_options') {
        var bundleSelection = ComponentResolver.extractBundleSelection(item.properties);
        if (!bundleSelection) {
          Logger.warn('Bundle selection not found for IO bundle variant', item.id);
          return [];
        }

        return ComponentResolver.resolveIOBundle(metafields.ioSelections, bundleSelection, item.quantity);
      }

      return [];
    },

    getParentTargetUnitPrice: function (metafields, resolvedComponents) {
      var parentPlan = null;

      for (var i = 0; i < resolvedComponents.length; i += 1) {
        if (resolvedComponents[i].planContext && resolvedComponents[i].planContext.parentPlan) {
          parentPlan = resolvedComponents[i].planContext.parentPlan;
          break;
        }
      }

      var parentPlanPrice = parentPlan ? Utils.normalizePrice(parentPlan.price) : null;
      if (parentPlanPrice !== null) return parentPlanPrice;

      return Utils.normalizePrice(metafields && metafields.variantPrice);
    },

    getResolvedChildLinePrice: function (resolvedComponent) {
      var component = resolvedComponent && resolvedComponent.component;
      var planContext = resolvedComponent && resolvedComponent.planContext;
      var childPlan = planContext && planContext.childPlan;
      var childPlanPrice = childPlan ? Utils.normalizePrice(childPlan.price) : null;

      if (!component || childPlanPrice === null) return null;

      return childPlanPrice * Utils.normalizeQuantity(component.quantity);
    },

    allocateBundlePricing: function (item, metafields, resolvedComponents) {
      var parentTargetUnitPrice = this.getParentTargetUnitPrice(metafields, resolvedComponents);
      if (parentTargetUnitPrice === null) {
        return resolvedComponents;
      }

      var bundleQuantity = Utils.normalizeQuantity(item.quantity);
      var targetSubtotal = Math.round(parentTargetUnitPrice * bundleQuantity);
      var childSubtotal = 0;
      var rawAllocations = [];

      resolvedComponents.forEach(function (resolvedComponent, index) {
        var childLinePrice = Expander.getResolvedChildLinePrice(resolvedComponent);
        if (childLinePrice === null) return;

        childSubtotal += childLinePrice;
        rawAllocations.push({
          index: index,
          childLinePrice: childLinePrice,
        });
      });

      if (!rawAllocations.length || childSubtotal <= 0 || targetSubtotal <= 0 || targetSubtotal >= childSubtotal) {
        return resolvedComponents;
      }

      var allocatedSubtotal = 0;
      rawAllocations.forEach(function (allocation) {
        var rawLinePrice = (allocation.childLinePrice * targetSubtotal) / childSubtotal;
        allocation.allocatedLinePrice = Math.floor(rawLinePrice);
        allocation.remainder = rawLinePrice - allocation.allocatedLinePrice;
        allocatedSubtotal += allocation.allocatedLinePrice;
      });

      var remainingCents = targetSubtotal - allocatedSubtotal;
      rawAllocations
        .slice()
        .sort(function (a, b) {
          return b.remainder - a.remainder;
        })
        .forEach(function (allocation) {
          if (remainingCents <= 0) return;
          allocation.allocatedLinePrice += 1;
          remainingCents -= 1;
        });

      var bundleDiscountPercent = Math.round(((childSubtotal - targetSubtotal) / childSubtotal) * 10000) / 100;
      var allocationByIndex = {};

      rawAllocations.forEach(function (allocation) {
        allocationByIndex[allocation.index] = allocation;
      });

      return resolvedComponents.map(function (resolvedComponent, index) {
        var allocation = allocationByIndex[index];
        if (!allocation) return resolvedComponent;

        var component = resolvedComponent.component;
        var planContext = resolvedComponent.planContext || {};
        var bestPlan = SellingPlanMapper.findPlanClosestToLinePrice(
          planContext.childPlans,
          component.quantity,
          allocation.allocatedLinePrice,
          planContext.childPlan
        );

        if (bestPlan) {
          planContext = Object.assign({}, planContext, {
            sellingPlanId: bestPlan.id,
            childPlan: bestPlan,
          });
        }

        var finalChildLinePrice = Expander.getResolvedChildLinePrice({
          component: component,
          planContext: planContext,
        });
        if (finalChildLinePrice === null) {
          finalChildLinePrice = allocation.childLinePrice;
        }

        return {
          component: component,
          planContext: planContext,
          pricing: {
            childLinePrice: Math.round(finalChildLinePrice),
            allocatedLinePrice: allocation.allocatedLinePrice,
            allocatedUnitPrice: Math.round(allocation.allocatedLinePrice / Utils.normalizeQuantity(component.quantity)),
            discountLineAmount: Math.max(0, Math.round(finalChildLinePrice) - allocation.allocatedLinePrice),
            discountPercent: bundleDiscountPercent,
            requiresPriceAdjustment: Math.round(finalChildLinePrice) > allocation.allocatedLinePrice,
          },
        };
      });
    },

    expandItem: function (item) {
      var metafields = MetafieldFetcher.fetch(item.id);

      if (!BundleDetector.isBundle(metafields) || !Utils.hasSellingPlan(item.selling_plan)) {
        return Promise.resolve({
          expanded: false,
          items: [item],
        });
      }

      if (!CONFIG.expandSubscriptionBundles) {
        Logger.log('Skipping subscription bundle expansion to preserve parent bundle selling-plan price.', item);
        return Promise.resolve({
          expanded: false,
          items: [item],
        });
      }

      var components = this.resolveBundleComponents(item, metafields);
      if (!components.length) {
        return Promise.resolve({
          expanded: false,
          items: [item],
        });
      }

      var parentContext = {
        productHandle: metafields.productHandle || null,
        productTitle: metafields.productTitle || null,
        variantId: item.id,
        sellingPlanId: item.selling_plan,
      };

      return Promise.all(
        components.map(function (component) {
          return SellingPlanMapper.resolveSellingPlanContext(parentContext, component)
            .catch(function (error) {
              Logger.warn('Selling plan mapping failed; falling back to parent selling plan ID.', error);
              return {
                sellingPlanId: String(item.selling_plan),
                parentPlan: null,
                childPlan: null,
                childPlans: [],
              };
            })
            .then(function (planContext) {
              return {
                component: component,
                planContext: planContext,
              };
            });
        })
      ).then(function (resolvedComponents) {
        return Expander.allocateBundlePricing(item, metafields, resolvedComponents).map(function (resolvedComponent) {
          var component = resolvedComponent.component;
          var planContext = resolvedComponent.planContext;
          var mappedSellingPlanId = planContext && planContext.sellingPlanId;
          var expandedItem = {
            id: component.id,
            quantity: component.quantity,
          };

          if (Utils.hasSellingPlan(mappedSellingPlanId || item.selling_plan)) {
            expandedItem.selling_plan = String(mappedSellingPlanId || item.selling_plan);
          }

          expandedItem.properties = Utils.buildSubscriptionBundleProperties(
            item.properties,
            parentContext,
            metafields,
            planContext,
            resolvedComponent.pricing
          );

          return expandedItem;
        });
      }).then(function (expandedItems) {
        return {
          expanded: true,
          items: expandedItems,
        };
      });
    },

    expandItems: function (items) {
      var self = this;

      return Promise.all(
        items.map(function (item) {
          return self.expandItem(item);
        })
      ).then(function (results) {
        var mergedItems = [];
        var didExpand = false;
        var expandedItemCount = 0;

        results.forEach(function (result) {
          if (result.expanded) {
            didExpand = true;
          }

          result.items.forEach(function (item) {
            mergedItems.push(item);
            expandedItemCount += item.quantity;
          });
        });

        if (!didExpand) return null;

        return {
          items: Utils.mergeItems(mergedItems),
          itemCount: expandedItemCount,
        };
      });
    },
  };

  var Interceptor = {
    _initialized: false,
    _processing: new WeakSet(),
    _pendingExpandedItemCounts: {},

    init: function () {
      if (this._initialized) return;

      this._interceptFetch();
      this._interceptForms();
      this._interceptCartEvents();

      this._initialized = true;
      Logger.log('Initialized');
    },

    _rememberPendingExpandedItemCount: function (sourceId, itemCount) {
      var normalizedSourceId = String(sourceId || '');
      if (!normalizedSourceId || !Number.isFinite(itemCount)) return;
      this._pendingExpandedItemCounts[normalizedSourceId] = itemCount;
    },

    _takePendingExpandedItemCount: function (sourceId) {
      var normalizedSourceId = String(sourceId || '');
      if (!normalizedSourceId) return null;

      if (!Object.prototype.hasOwnProperty.call(this._pendingExpandedItemCounts, normalizedSourceId)) {
        return null;
      }

      var itemCount = this._pendingExpandedItemCounts[normalizedSourceId];
      delete this._pendingExpandedItemCounts[normalizedSourceId];
      return itemCount;
    },

    _interceptFetch: function () {
      var self = this;

      window.fetch = function (input, options) {
        var meta = Utils.getFetchMeta(input, options);
        if (!Utils.isCartAddRequest(meta)) {
          return _originalFetch(input, options);
        }

        return self
          ._handleCartAdd(meta.body)
          .then(function (response) {
            if (response) return response;
            return _originalFetch(input, options);
          })
          .catch(function (error) {
            Logger.error('Fetch interception failed:', error);
            return _originalFetch(input, options);
          });
      };
    },

    _handleCartAdd: function (body) {
      var self = this;
      var parsedRequest = Utils.parseCartAddBody(body);
      if (!parsedRequest) return Promise.resolve(null);

      return Expander.expandItems(parsedRequest.items)
        .then(function (expanded) {
          if (!expanded) return null;

          if (parsedRequest.sections && parsedRequest.items.length === 1) {
            self._rememberPendingExpandedItemCount(parsedRequest.items[0].id, expanded.itemCount);
          }

          var payload = {
            items: expanded.items,
          };

          if (parsedRequest.sections) {
            payload.sections = parsedRequest.sections;
          }

          if (parsedRequest.sections_url) {
            payload.sections_url = parsedRequest.sections_url;
          }

          return CartAPI.addItems(payload).then(function (result) {
            if (!result.ok) {
              return Utils.buildResponse(
                result.status,
                Utils.buildErrorPayload(
                  result.status,
                  result.data,
                  result.text || 'Unable to add this bundle to the cart.'
                )
              );
            }

            var responsePayload = Utils.buildSuccessPayload(result.data, {
              itemCount: expanded.itemCount,
            });

            CartAPI.requestBundleDiscountSync();

            if (!parsedRequest.sections && parsedRequest.bodyType.indexOf('json') === 0) {
              return CartAPI.getCart().then(function (cart) {
                CartAPI.dispatchCartUpdate(cart, {
                  itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
                  sections: responsePayload.sections || {},
                });

                return Utils.buildResponse(result.status, responsePayload);
              });
            }

            return Utils.buildResponse(result.status, responsePayload);
          });
        })
        .catch(function (error) {
          Logger.error('Bundle expansion failed:', error);
          return Utils.buildResponse(
            422,
            Utils.buildErrorPayload(422, null, error.message || 'Unable to expand this subscription bundle.')
          );
        });
    },

    _interceptForms: function () {
      var self = this;

      document.addEventListener('submit', function (event) {
        if (event.defaultPrevented) return;

        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.matches(CONFIG.selectors.productForm)) return;
        if (self._processing.has(form)) return;

        var variantInput = form.querySelector(CONFIG.selectors.variantInput);
        if (!variantInput) return;

        var sellingPlanInput = form.querySelector(CONFIG.selectors.sellingPlanInput);
        var sellingPlan =
          sellingPlanInput && !sellingPlanInput.disabled && Utils.hasSellingPlan(sellingPlanInput.value)
            ? String(sellingPlanInput.value)
            : null;

        if (!sellingPlan) return;
        if (!CONFIG.expandSubscriptionBundles) return;

        var metafields = MetafieldFetcher.fetch(variantInput.value);
        if (!BundleDetector.isBundle(metafields)) return;

        event.preventDefault();
        self._processing.add(form);

        self
          ._handleFormSubmit(form, metafields, sellingPlan)
          .catch(function (error) {
            Logger.error('Form interception failed:', error);
          })
          .finally(function () {
            self._processing.delete(form);
          });
      });
    },

    _handleFormSubmit: function (form, metafields, sellingPlan) {
      var variantInput = form.querySelector(CONFIG.selectors.variantInput);
      if (!variantInput) return Promise.reject(new Error('Variant input not found.'));

      var variantId = String(variantInput.value);
      var quantityInput = form.querySelector(CONFIG.selectors.quantityInput);
      var quantity = Utils.normalizeQuantity(quantityInput ? quantityInput.value : 1);
      var properties = Utils.extractFormProperties(form);
      var item = {
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlan,
        properties: properties,
      };

      return Expander.expandItems([item]).then(function (expanded) {
        if (!expanded) {
          throw new Error('No bundle expansion was required.');
        }

        var sectionIds = Utils.getCartSectionIds();
        var payload = {
          items: expanded.items,
          sections_url: window.location.pathname,
        };

        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
        }

        return CartAPI.addItems(payload).then(function (result) {
          if (!result.ok) {
            throw new Error(
              (result.data && (result.data.description || result.data.message)) ||
                result.text ||
                'Unable to add this bundle to the cart.'
              );
          }

          CartAPI.requestBundleDiscountSync();

          return CartAPI.getCart().then(function (cart) {
            CartAPI.dispatchCartUpdate(cart, {
              sourceId: variantId,
              source: 'simple-bundles-expander',
              itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
              variantId: variantId,
              sections: (result.data && result.data.sections) || {},
            });

            CartAPI.openCartDrawer();
          });
        });
      });
    },

    _interceptCartEvents: function () {
      var self = this;

      document.addEventListener(
        'cart:update',
        function (event) {
          if (!event || !event.detail || !event.detail.data) return;
          if (event.detail.data.source !== 'product-form-component') return;

          var pendingItemCount = self._takePendingExpandedItemCount(event.detail.sourceId);
          if (pendingItemCount === null) return;

          event.detail.data.itemCount = pendingItemCount;
        },
        true
      );
    },
  };

  // Debug API only exposed when explicitly opted in via window.__SB_DEBUG__ = true
  // (set before the script loads, or via DevTools then call window.SBExpanderDebug = SBExpanderDebug)
  // This keeps internal bundle logic out of the global namespace in production.
  if (window.__SB_DEBUG__) {
    window.SBExpanderDebug = {
      checkVariant: function (variantId) {
        var metafields = MetafieldFetcher.fetch(variantId);
        console.log('Variant', variantId, metafields);
        console.log('Is bundle:', BundleDetector.isBundle(metafields));
        console.log('Bundle type:', BundleDetector.getBundleType(metafields));
        return metafields;
      },

      showLiquidData: function () {
        console.log(window.__SB_VARIANT_METAFIELDS__);
      },

      testIOMatch: function (variantId, bundleSelectionString) {
        var metafields = MetafieldFetcher.fetch(variantId);
        return ComponentResolver.resolveIOBundle(metafields.ioSelections, bundleSelectionString, 1);
      },

      testSellingPlanMap: function (parentVariantId, parentSellingPlanId, childVariantId, childProductHandle) {
        var metafields = MetafieldFetcher.fetch(parentVariantId);

        return SellingPlanMapper.resolveSellingPlan(
          {
            productHandle: metafields.productHandle || null,
            variantId: parentVariantId,
            sellingPlanId: parentSellingPlanId,
          },
          {
            id: childVariantId,
            productHandle: childProductHandle,
            quantity: 1,
          }
        ).then(function (mappedSellingPlanId) {
          console.log('Mapped child selling plan:', mappedSellingPlanId);
          return mappedSellingPlanId;
        });
      },
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      Interceptor.init();
    });
  } else {
    Interceptor.init();
  }

  window.SimpleBundlesExpander = {
    CONFIG: CONFIG,
    Interceptor: Interceptor,
    MetafieldFetcher: MetafieldFetcher,
    BundleDetector: BundleDetector,
    ComponentResolver: ComponentResolver,
    SellingPlanMapper: SellingPlanMapper,
    CartAPI: CartAPI,
    Logger: Logger,
  };
})();
